import axios from "axios";
import Swal from 'sweetalert2';
import _ from "lodash";

const methods = {
    onComplete() {
    },
    validateBasicTab: async function () {
        var inputs = document.getElementsByClassName('file-input');
        let inputsArray = [...inputs];
        
        if (inputsArray) {
            let inputDocs = inputsArray.slice(1);
            inputDocs.forEach(element => {
                element.setAttribute('data-test', 'docs');
            });
        }
        
        var valid = true;
        var basicStep = this.$refs.basicStep;

        if (valid = basicStep.validate()) {
            this.setCpfText(this.basicModel.document);
            this.getPhone(this.basicModel.phone);
            this.getEmail(this.basicModel.email);
            this.getBasicData();
            valid = await basicStep.save();
        } else {
            Swal.fire(
                "Por favor corrigir os campos com anotações em vermelho para prosseguir com o cadastro",
                "",
                "success"
            );
        }

        return valid;
    },
    validateSecondTab: async function () {
        var valid = true;
        var vehicleStep = this.$refs.vehicleStep;

        if (valid = vehicleStep.validate()) {
            valid = await vehicleStep.save();
        } else {
            Swal.fire(
                "Por favor corrigir os campos com anotações em vermelho para prosseguir com o cadastro",
                "",
                "success"
            );
        }

        return valid;
    },
    validateThirdTab: async function () {
        var valid = true;
        var bankStep = this.$refs.bankStep;

        if (valid = bankStep.validate()) {
            valid = await bankStep.save();
        } else {
            Swal.fire(
                "Por favor corrigir os campos com anotações em vermelho para prosseguir com o cadastro",
                "",
                "success"
            );
        }

        return valid;
    },
    validateFourthTab: async function () {
        const pixStep = this.$refs.pixStep;
        return await pixStep.save();
    },
    validateFifthTab: async function () {
        var valid = true;
        var documentsStep = await this.$refs.documentsStep;

        if (valid = documentsStep.validate()) {
            valid = await documentsStep.save();
        } else {
            Swal.fire(
                "Por favor corrigir os campos com anotações em vermelho para prosseguir com o cadastro",
                "",
                "success"
            );
        }

        return valid;
    },
    getEmail(email) {
        var text_email = document.getElementById("text_email");
        if (text_email)
            text_email.innerHTML = this.hideValue(email, 1, 3);
    },
    getBasicData() {
        var bankStep = this.$refs.bankStep;
        if (bankStep && bankStep.basic_data) {
            this.bankModel.holder = this.basicModel.first_name + " " + this.basicModel.last_name;
            this.bankModel.document_individual = this.basicModel.document;
        }
    },
    setProviderId(id) {
        this.providerId = id;
    },
    hideValue(value, start, end) {
        let text = value.split('');

        for (let i = 0; i < text.length; i++) {
            if (start <= i && i <= end) {
                text[i] = '*';
            }
        }

        return text.join('');
    },
    setCpfText(cpf) {
        var text_cpf = document.getElementById("text_cpf");
        if (text_cpf)
            text_cpf.innerHTML = this.hideValue(cpf, 0, 7);
    },
    getCpf(cpf) {
        this.setCpfText(cpf);

        this.basicModel.document_individual = cpf;
        this.bankModel.document_individual = cpf;

        axios.get(this.base_url + '/api/v2/provider/wizard/get_provider_data_by_cpf/' + cpf.replace(/\D/g, ""), {
            crossDomain: true,
        }).then((response) => {
            var basicData = response.data.basic_data;
            var vehicleData = response.data.vehicle_data;

            if (response.data.institution_id)
                this.basicModel.institution_id = response.data.institution_id;

            if (basicData) {
                this.providerId = basicData.id;
                this.basicModel.first_name = basicData.first_name;
                this.basicModel.last_name = basicData.last_name;
                this.basicModel.birthday = basicData.birthday;
                this.basicModel.email = basicData.email;
                this.basicModel.document = cpf;
                this.basicModel.document_individual = cpf;
                this.basicModel.phone = basicData.phone;
                this.basicModel.zipcode = basicData.zipcode;
                this.basicModel.country = basicData.country;
                this.basicModel.address = basicData.address;
                this.basicModel.address_number = basicData.address_number;
                this.basicModel.address_complements = basicData.address_complements;
                this.basicModel.address_neighbour = basicData.address_neighbour;
                this.basicModel.address_city = basicData.address_city;
                this.basicModel.state = basicData.state;
            }

            if (vehicleData) {
                this.vehicleModel.car_model = vehicleData.car_model;
                this.vehicleModel.car_number = vehicleData.car_number;
                this.vehicleModel.car_brand = vehicleData.car_brand;
            }
        }).catch((error) => {
            // handle error
        });
    },
    getProvider(url) {
        axios.get(url, {
            crossDomain: true,
        }).then((response) => {
            var basicData = response.data.basic_data;
            var vehicleData = response.data.vehicle_data;
            var serviceData = response.data.service_data;
            var bankData = response.data.bank_data;
            var documentData = response.data.document_data;
            var documentsStep = this.$refs.documentsStep;

            if (response.data.institution_id) {
                this.basicModel.institution_id = response.data.institution_id;
            }

            if (basicData) {
                this.providerId = basicData.id;
                this.basicModel.first_name = basicData.first_name;
                this.basicModel.last_name = basicData.last_name;
                this.basicModel.birthday = basicData.birthday;
                this.basicModel.email = basicData.email;
                this.basicModel.document = basicData.document;
                this.basicModel.document_individual = basicData.document;
                this.bankModel.document_individual = basicData.document;
                this.basicModel.phone = basicData.phone;
                this.basicModel.zipcode = basicData.zipcode;
                this.basicModel.country = basicData.country;
                this.basicModel.address = basicData.address;
                this.basicModel.address_number = basicData.address_number;
                this.basicModel.address_complements = basicData.address_complements;
                this.basicModel.address_neighbour = basicData.address_neighbour;
                this.basicModel.address_city = basicData.address_city;
                this.basicModel.state = basicData.state;
                this.picture_url = basicData.picture;
                var basicStep = this.$refs.basicStep;
                if (basicStep) {
                    this.$nextTick(() => {
                        basicStep.setPicture();
                    });
                }
            }

            if (vehicleData) {
                this.vehicleModel.car_model = vehicleData.car_model;
                this.vehicleModel.car_number = vehicleData.car_number;
                this.vehicleModel.car_brand = vehicleData.car_brand;
                if (serviceData) {
                    this.vehicleModel.provider_type = serviceData;
                }
            }

            if (bankData) {
                this.bankModel.holder = bankData.holder;
                this.bankModel.bank_id = bankData.bank_id;
                this.bankModel.agency = bankData.agency;
                this.bankModel.account = bankData.account;
                this.bankModel.document_individual = bankData.document;
                this.bankModel.account_digit = bankData.account_digit;
                this.bankModel.person_type = bankData.person_type;
                this.bankModel.account_type = bankData.account_type;
            }

            if (documentData) {
                documentsStep.document_array = documentData;
                for (var document of documentsStep.document_array) {
                    if (document.date_validity) {
                        var date = new Date(document.date_validity);
                        documentsStep.documentDates[`date-${document.document_id}`] = (this.adicionaZero(date.getDate().toString()) + "/" + (this.adicionaZero(date.getMonth() + 1).toString()) + "/" + date.getFullYear());
                    }
                }
            }
        }).catch((error) => {
            // handle error
        });
    },
    adicionaZero(numero) {
        if (numero <= 9)
            return "0" + numero;
        else
            return numero;
    },
    getPhone(phone) {
        var text_phone = document.getElementById("text_phone");
        if (text_phone)
            text_phone.innerHTML = this.hideValue(phone, 0, 7);
    },
    trans(key) {
        return _.get(window.lang, key, key);
    },
}
export default methods;

export function validateCnpj(value) {
    let matched = value.replace(/\D/g, '');
    let cnpj = matched;
    if (!cnpj || cnpj.length != 14
        || cnpj == "00000000000000"
        || cnpj == "11111111111111"
        || cnpj == "22222222222222"
        || cnpj == "33333333333333"
        || cnpj == "44444444444444"
        || cnpj == "55555555555555"
        || cnpj == "66666666666666"
        || cnpj == "77777777777777"
        || cnpj == "88888888888888"
        || cnpj == "99999999999999")
        return false
    var size = cnpj.length - 2
    var numbers = cnpj.substring(0, size)
    var digits = cnpj.substring(size)
    var sum_total = 0
    var pos = size - 7
    for (var i = size; i >= 1; i--) {
        sum_total += numbers.charAt(size - i) * pos--
        if (pos < 2) pos = 9
    }
    var result = sum_total % 11 < 2 ? 0 : 11 - sum_total % 11
    if (result != digits.charAt(0)) return false;
    size = size + 1
    numbers = cnpj.substring(0, size)
    sum_total = 0
    pos = size - 7
    for (var i = size; i >= 1; i--) {
        sum_total += numbers.charAt(size - i) * pos--
        if (pos < 2) pos = 9
    }
    result = sum_total % 11 < 2 ? 0 : 11 - sum_total % 11
    if (result != digits.charAt(1)) return false
    return true;

}

